function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "clock--green");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u2693\\uFE0F-The-Shipyard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Artboard",
  transform: "translate(-65.000000, -18.000000)",
  fill: "#ADC82E"
}, React.createElement("path", {
  d: "M73.3809524,18.3809524 C77.7992304,18.3809524 81.3809524,21.9626744 81.3809524,26.3809524 C81.3809524,30.7992304 77.7992304,34.3809524 73.3809524,34.3809524 C68.9626744,34.3809524 65.3809524,30.7992304 65.3809524,26.3809524 C65.3809524,21.9626744 68.9626744,18.3809524 73.3809524,18.3809524 Z M73.3809524,20.2633053 C70.0022692,20.2633053 67.2633053,23.0022692 67.2633053,26.3809524 C67.2633053,29.7596356 70.0022692,32.4985994 73.3809524,32.4985994 C76.7596356,32.4985994 79.4985994,29.7596356 79.4985994,26.3809524 C79.4985994,23.0022692 76.7596356,20.2633053 73.3809524,20.2633053 Z M73.3809524,21.3221289 C73.8607654,21.3221289 74.2567189,21.6811737 74.3147958,22.1452461 L74.3221289,22.2633053 L74.3221289,26.3880112 L76.1548005,27.3038444 C76.580978,27.5169332 76.7748402,28.0097327 76.6251372,28.4484936 L76.5757074,28.5665652 C76.3432469,29.0314861 75.7779076,29.2199326 75.3129866,28.9874721 L72.9600455,27.8110015 L72.9575751,27.8097619 C72.8493488,27.7554494 72.7527891,27.6802914 72.6733278,27.5897551 C72.6571993,27.5717007 72.642127,27.5530905 72.6278209,27.5339829 C72.6192727,27.5223465 72.6109716,27.5107538 72.6029313,27.4989689 C72.5915044,27.4823132 72.5804399,27.4648339 72.5699746,27.4470346 C72.558103,27.4269787 72.5472238,27.4069023 72.5370695,27.3864029 C72.5340056,27.3798485 72.530644,27.3728294 72.5273705,27.3657717 C72.4996847,27.3066557 72.4782556,27.2445888 72.4634739,27.1799882 C72.4582076,27.1562401 72.4537801,27.1329986 72.4502288,27.1095946 C72.4491166,27.1025262 72.4480669,27.0949008 72.447109,27.0872469 L72.4447847,27.0672881 C72.4420689,27.0416049 72.4404044,27.015765 72.4397759,26.9898344 L72.4397759,26.9691877 L72.4397759,22.2633053 C72.4397759,21.7435079 72.861155,21.3221289 73.3809524,21.3221289 Z",
  id: "clock--green"
})));

var SvgClockGreen = function SvgClockGreen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgClockGreen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clock--green.b6d5d67a.svg";
export { ForwardRef as ReactComponent };